module.exports = __webpack_public_path__ + "media/Windpark_Rot_am_See_Referenz.8624a4c4.mp4";